export default __webpack_public_path__ + "static/media/icon_rewards_qr.f58dd3d0.svg";